import React from 'react'
import ScrollToTopButton from '../pages/ScrollToTopButton'
import UnderlineWithIcon from '../components/UnderlineWithIcon';
const Undergrad = () => {
  return (
    <div>
      
 <br/>



    <div class="sidebar-page-container">
        <div class="auto-container">
            <div class="row">
                
             
                <div class="content-side col-xl-9 col-lg-8 order-lg-2">
                    <div class="services-single">
                        <div class="inner-box">
                            <div class="big-image">
                                <img src="assets/images/resource/service-9.jpg" alt="" />
                            </div>
                            <div className="sec-title">
              
           
                            <h3 className='campuses-heading' style={{textAlign:'center'}}>UNDERGRADUATE ACADEMIC PROGRAM</h3>
								<UnderlineWithIcon/>
                            </div>
                            <div class="text">
                                <p>
  Admas University remains responsive to the evolving needs of society, guiding the expansion and development of academically relevant and socially impactful undergraduate programs. 
  In fulfilling this commitment, the university has launched a diverse range of undergraduate studies aimed at equipping students with practical skills and knowledge to meet the growing demand for qualified professionals across various fields throughout the country.
</p>

                            
                                 
                            </div>

                            <div class="facts">
                                <h3>ADMISSION CRITERIA</h3>
                                <div class="text">
                               &nbsp;&nbsp;&nbsp;&nbsp; To be eligible for admission to our university, applicants must meet the following criteria:
                                </div>
                                    <div>
										&nbsp;&nbsp;&nbsp;&nbsp;<a href ="/admissionCriteria"> Click for Undergraduate Admission Criteria </a>
								</div>
                               </div>

                            <div class="featured-blocks">
                                <div class="row">
                                    
                                  
                                    <div class="featured-block col-md-10">
                                        <div class="featured-inner">
                                            <div class="content">
                                                <div class="icon-box">
                                                    <span class="icon flaticon-work-team"></span>
                                                </div>
                                                <h3>DURATION OF THE PROGRAMS</h3>
<div class="text">
  Undergraduate programs at Admas University typically span four or more years, depending on the field of study. 
  These programs are structured across multiple semesters, combining comprehensive coursework with practical training and a final research-based graduation project.
</div>

                                            </div>
                                        </div>
                                    </div>
                                    
                                  
                                    <div className="featured-block col-md-6">
      <div className="featured-inner">
        <div className="content">
          <div className="icon-box">
            <span className="icon flaticon-deadline"></span>
          </div>
          
        </div>
      </div>
    </div>
                                    
                             
                                    
                                   
                                  
                                    
                                </div>
                            </div>
                            
                          
                           
                        </div>
                    </div>
                </div>
                
              
                <div class="sidebar-side col-xl-3 col-lg-4">
                    <aside class="sidebar">
                        
                    



                        <div class="sidebar-widget sidebar-blog-category">
                          <ul className='blog-cat'>
                    <li className='active'><a href='performance-upgrade.html'>Undergraduate Academic Programs</a></li>
                    <li><a href='/bscacfn'>Accounting & Finances</a></li>
                    <li><a href='/bscbm'>Business Management</a></li>
                    <li><a href='/bscmmkt'>Marketing Management</a></li>
                    <li><a href='/bsccs'>Computer Science</a></li>
                    <li><a href='/bscedpm'>EDPM</a></li>
                    <li><a href='/bsceco'>Economics</a></li>
                    <li><a href='/bscagri'>Agricultural Economics</a></li>
                    <li><a href='/bscagriext'>Rural Dev't & Agri. Extension</a></li>
                  </ul>
                        </div>
                        
                    
                      

                      
                        <div class="sidebar-widget contact-info-widget">
                            <div class="sidebar-title style-two">
                                <h2>Contact Us</h2>
                            </div>
                            <div class="inner-box">
                                <ul>
                                    <li><span class="icon fas fa-phone"></span>0116687671</li>
                                    <li><span class="icon fas fa-paper-plane"></span>https://t.me/AdmasAA</li>
                                </ul>
                            </div>
                        </div>
                        
                    </aside>
                </div>
                
            </div>
        </div>
    </div>
    <ScrollToTopButton/>
    </div>
  )
}

export default Undergrad